export const EXTENSION_NAME = "em-live-traffic"
